<template>
	<div class="ai_container">
		<Header :title="'스피드메이트 AI 견적'" :isShowMenu="true" />
		<div class="ai_wrapper_no_padding" style="position:relative">
			<div class="main_title_container">
				<img src="/static/images/ai/main/main.png" width="100%" alt="메인" />
				<div class="main_title_wrapper">
					<h1 class="heading_2">사고수리AI 견적<br>
						티맵에서만 <strong class="heading_1 f_primary_1">무료</strong> 이벤트
					</h1>
					<div>
						<p>TMAP 회원을 위한 특별 오픈 프로모션</p>
						<img src="/static/images/ai/main/tmap_collabo.png" width="162" alt="티맵x스피드메이트" />
					</div>
				</div>
				<p class="possible_car_brands body_10_M f_gray_10">• 견적 가능 차량 브랜드: 벤츠, BMW, 아우디, 폭스바겐 등</p>
			</div>
			<div class="main_info_wrapper">
				<ul>
					<li class="body_9">AI가 수리부위 사진을 보고 부품부터 공임 견적까지 자동으로 산출해줘요.</li>
					<li class="body_9">공업사 방문없이 어디서든 빠르고 편하게 사고수리 견적을 확인하세요.</li>
				</ul>
			</div>
			<div class="main_caution_wrapper">
				<div>
					<b class="heading_9">유의사항</b>
					<p class="body_9 f_gray_4" style="marginTop:4px">AI견적은 업계 평균 공임으로 계산되요. 수리 시 방문하는 공업사에 따라 실제 수리비용과 차이가 발생할 수 있어요.</p>
				</div>
			</div>
			<section class="main_section">
				<div class="main_section_label body_10_M">혜택 1</div>
				<h3 class="heading_3">견적 비용 특별 할인</h3>
				<img src="/static/images/ai/main/discount.png" alt="무료" />
			</section>
			<!-- <section class="main_section" style="backgroundColor: var(--gray-scale-11)">
		  <div class="main_section_label body_10_M">혜택 2</div>
		  <h3 class="heading_3">견적 확인하면<br>특별 할인 쿠폰 제공</h3>
		  <img src="/static/images/ai/main/oil_coupon.png" alt="엔진오일쿠폰"/>
		  <ul>
			<li class="body_9">스피드메이트 매장에서만 사용할 수 있어요.</li>
		  </ul>
		</section> -->
			<!-- <section class="main_section">
		  <div class="main_section_label body_10_M">혜택 3</div>
		  <h3 class="heading_3">제휴 공장 방문 시<br>견적 비용 100% 환급</h3>
		  <img src="/static/images/ai/main/receipt.png" alt="영수증"/>
		  <ul>
			<li class="body_9">제휴 공장 방문 시에만 환급이 가능해요.</li>
		  </ul>
		</section> -->
			<section class="main_list_section">
				<h4 class="heading_4">쉽고 간편한 이용 방법을<br>확인해보세요</h4>
				<ul>
					<li v-for="item in items" :key="item.title">
						<div class="main_image_wrapper">
							<img :src="item.imageUrl" />
						</div>
						<div>
							<p class="heading_7" style="marginBottom:8px">{{ item.title }}</p>
							<p class="body_8_M f_gray_4" style="whiteSpace:pre-line">{{ item.content }}</p>
						</div>
					</li>
				</ul>
			</section>
		</div>
		<Footer style="padding-top: 20px; padding-bottom: 90px;"/>
		<BottomFloatButton :label="'내 차 견적 산출하기'" :isFull="false" :onClick="fnOnclick" />
	</div>
</template>

<script>
import Header from '@/components/ai/AiHeader.vue'
import BottomFloatButton from '@/components/ai/AiBottomFloatButton.vue'
import Footer from '@/components/ai/AiFooter.vue'

export default {
	data() {
		return {
			isShowMenu: false,
			items: [
				{
					title: '1. 차량모델 조회',
					content: '차량번호로 간편하게 조회하세요.\n* 미조회 시 수기입력 가능',
					imageUrl: '/static/images/ai/main/id.png'
				},
				{
					title: '2. 사진 촬영 및 업로드',
					content: '제시되는 가이드에 따라 수리 부위를 촬영해주세요.',
					imageUrl: '/static/images/ai/main/camera.png'
				},
				{
					title: '3. 온라인 결제',
					content: '견적 확인을 위해 산출 비용을 결제해주세요.',
					imageUrl: '/static/images/ai/main/phone.png'
				},
				{
					title: '4. 견적 확인',
					content: '촬영한 사진을 바탕으로 AI가 자동 견적을 보여드려요.',
					imageUrl: '/static/images/ai/main/note.png'
				},
				{
					title: '5. 사고 수리 상담',
					content: 'AI견적을 바탕으로 상담 가능한 공업사를 소개해드려요.',
					imageUrl: '/static/images/ai/main/repair.png'
				}
			]
		}
	},
	components: {
		Header,
		BottomFloatButton,
		Footer
	},
	methods: {
		handleHistory() {
			alert('견적내역 보기')
		},
		handleEstimate() {
			alert('견적 확인하기')
		},
		fnOnclick() {
			this.$router.push({ name: 'AiSearchCar' })
		}
	},
	mounted() {

	}
}
</script>



// WEBPACK FOOTER //
// src/views/ai/AiMain.vue